module.exports = __webpack_public_path__ + "static/parade-2020-house42-4b2e4447a22968d4e576208bc6bcd370.jpg";